import { render } from "./FullMouthRestLongevity.vue?vue&type=template&id=75353b7c"
import script from "./FullMouthRestLongevity.vue?vue&type=script&lang=js"
export * from "./FullMouthRestLongevity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__